import type { MailboxInfo } from "owa-client-types";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getRegisteredUnifiedInboxCopilotResolver } from "./unifiedInboxCopilotResolver";

/**
 * Resolves a unified inbox mailbox info to a concrete account, otherwise returns
 * the given mailbox info unchanged.
 *
 * For a unified inbox this returns the default Copilot chat account computed by
 * the resolver registered via `registerUnifiedInboxCopilotResolver` (the
 * prioritized Copilot-eligible account within the unified inbox). Until that
 * resolver is registered it falls back to the global settings account.
 */
export default function getUnifiedInboxResolvedMailboxInfoOrSelf(mailboxInfo: MailboxInfo): MailboxInfo {
    if (!isUnifiedInboxMailboxInfo(mailboxInfo)) {
        return mailboxInfo;
    }
    
    const resolver = getRegisteredUnifiedInboxCopilotResolver();
    return resolver ? resolver(mailboxInfo) : getGlobalSettingsAccountMailboxInfo();
}
